'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var mustache = require('mustache');
var SessionContext = require('../../providers/SessionContext.js');
var useFormState = require('./useFormState.js');
var index = require('../../providers/ClaimBuilder/index.js');
var useAnalytics = require('../../providers/useAnalytics.js');
var useTitanAnalytics = require('../../providers/titan/useTitanAnalytics.js');
var React = require('react');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var mustache__default = /*#__PURE__*/_interopDefaultLegacy(mustache);

const useOrderLookupForm = options => {
  var _claimEligibilityErro;
  const logEvent = useAnalytics["default"]();
  const titan = useTitanAnalytics["default"]();
  const {
    useEligibilityQuery,
    claimTypeOptionActions,
    apiErrorMessages: {
      claimsOrderLookupApiErrorOrderNotFound,
      claimsOrderLookupApiErrorUnknown
    }
  } = options;
  const {
    state: {
      cartId
    },
    handleOrderLookupSuccess
  } = index.useClaimBuilder();
  const {
    retailerMoniker,
    orderNumber,
    localeCountry,
    localeLanguage,
    returnsPortalUrlTemplate,
    email,
    claimType: sessionClaimTypeOption,
    setOrderNumber
  } = SessionContext.useSession();
  const [submitEnabled, setSubmitEnabled] = React.useState(true);
  const [loading, setLoading] = React.useState(false);
  const claimTypeOptionClaimTypes = {
    ItemMissing: index.ClaimType.ItemMissing,
    ItemDamaged: index.ClaimType.ItemDamaged,
    PackageMissing: index.ClaimType.PackageMissing,
    WrongItem: index.ClaimType.WrongItem
  };
  const [getClaimEligibility, {
    loading: claimEligibilityLoading,
    called: claimEligibilityCalled,
    error: claimEligibilityError
  }] = useEligibilityQuery({
    onError: () => {
      const claimType = values !== null && values !== void 0 && values.claimTypeOption ? claimTypeOptionClaimTypes[values === null || values === void 0 ? void 0 : values.claimTypeOption] : undefined;
      const orderLookupErrorMessage = claimEligibilityError === null || claimEligibilityError === void 0 ? void 0 : claimEligibilityError.graphQLErrors[0].message;
      titan === null || titan === void 0 ? void 0 : titan.track({
        event: 'products_searched',
        properties: {
          order_id: orderNumber,
          filters: [{
            type: 'reason',
            value: claimType
          }],
          extra_properties: [{
            key: 'request_result',
            value: 'ERROR'
          }, {
            key: 'request_error_message',
            value: orderLookupErrorMessage
          }]
        }
      })
      // eslint-disable-next-line no-console
      .catch(e => console.error(e));
    },
    onCompleted: claimEligibility => {
      const claimType = values !== null && values !== void 0 && values.claimTypeOption ? claimTypeOptionClaimTypes[values === null || values === void 0 ? void 0 : values.claimTypeOption] : undefined;
      if (!claimEligibility || !claimType) throw new Error('Expected claimEligibility and claimType to have values');
      titan === null || titan === void 0 ? void 0 : titan.track({
        event: 'products_searched',
        properties: {
          order_id: orderNumber,
          filters: [{
            type: 'reason',
            value: claimType
          }],
          extra_properties: [{
            key: 'request_result',
            value: 'SUCCESS'
          }]
        }
      })
      // eslint-disable-next-line no-console
      .catch(e => console.error(e));
      logEvent({
        event_type: useAnalytics.ClaimsEventTypes.ORDER_LOOKUP_SUCCESS,
        event_component: useAnalytics.ClaimsEventComponents.NTH_KIT_CLAIMS_ORDER_LOOKUP,
        page_step: useAnalytics.ClaimsPageStep.ORDER_LOOKUP,
        order_number: claimEligibility.orderNumber,
        claim_reason: claimType
      });
      handleOrderLookupSuccess({
        claimEligibility,
        claimType
      });
    }
  });
  const handleSubmit = () => {
    if (!(localeCountry && localeLanguage)) {
      // TODO: Right now the getClaimEligibilityInfo API requires a language
      // and country. The graphql API reflects that. I need to talk to Allen
      // about whether or not language and country are actually required
      throw new Error('localeCountry and localeLanguage are required to be set');
    }
    const {
      claimTypeOption
    } = values;
    if (!claimTypeOption) throw new Error('Expected claimTypeOption to have a value');
    logEvent({
      event_type: useAnalytics.ClaimsEventTypes.ORDER_LOOKUP_CLICK_NEXT,
      event_component: useAnalytics.ClaimsEventComponents.NTH_KIT_CLAIMS_ORDER_LOOKUP,
      page_step: useAnalytics.ClaimsPageStep.ORDER_LOOKUP,
      order_number: orderNumber,
      claim_reason: claimTypeOption
    });
    const claimTypeOptionAction = claimTypeOptionActions[claimTypeOption];
    if ((claimTypeOptionAction === null || claimTypeOptionAction === void 0 ? void 0 : claimTypeOptionAction.actionType) === 'REDIRECT_TO_NARVAR_RETURNS_PORTAL') {
      const href = mustache__default["default"].render(returnsPortalUrlTemplate ?? '', {
        retailer: retailerMoniker,
        orderNumber: values.orderNumber,
        email: values.email
      });
      titan === null || titan === void 0 ? void 0 : titan.track({
        event: 'order_cancelled',
        properties: {
          order_id: orderNumber,
          filters: [{
            type: 'reason',
            value: claimTypeOption
          }],
          extra_properties: [{
            key: 'cancel_reason',
            value: 'REDIRECT_TO_NARVAR_RETURNS_PORTAL'
          }, {
            key: 'cancel_url',
            value: href
          }]
        }
      })
      // eslint-disable-next-line no-console
      .catch(e => console.error(e));
      window.location.href = href;
      setLoading(true);
    } else {
      const claimType = claimTypeOptionClaimTypes[claimTypeOption];
      if (!claimType) throw new Error('Expected claimType to have a value');
      setOrderNumber(values.orderNumber);
      getClaimEligibility({
        variables: {
          orderNumber: values.orderNumber,
          email: values.email,
          localeCountry,
          localeLanguage,
          retailerMoniker,
          claimType,
          cartId
        }
      });
    }
  };
  const {
    state: {
      values,
      errors
    },
    onChange,
    onSubmit
  } = useFormState["default"]({
    handleSubmit
  }, {
    orderNumber,
    email: email ?? '',
    claimTypeOption: sessionClaimTypeOption
  });
  const {
    claimTypeOption
  } = values;
  React.useEffect(() => {
    var _claimTypeOptionActio;
    if (claimTypeOption && ((_claimTypeOptionActio = claimTypeOptionActions[claimTypeOption]) === null || _claimTypeOptionActio === void 0 ? void 0 : _claimTypeOptionActio.actionType) === 'PREVENT_SUBMIT_SHOW_HELPER_TEXT') {
      setSubmitEnabled(false);
    } else {
      setSubmitEnabled(true);
    }
  }, [claimTypeOption, claimTypeOptionActions]);
  React.useEffect(() => {
    if (claimEligibilityError && !claimEligibilityLoading) {
      logEvent({
        event_type: useAnalytics.ClaimsEventTypes.ORDER_LOOKUP_FAILURE,
        event_component: useAnalytics.ClaimsEventComponents.NTH_KIT_CLAIMS_ORDER_LOOKUP,
        page_step: useAnalytics.ClaimsPageStep.ORDER_LOOKUP,
        order_number: orderNumber,
        claim_reason: claimTypeOption
      });
    }
  }, [claimEligibilityError, claimEligibilityLoading, claimTypeOption, logEvent, orderNumber]);

  // TODO: Talk with Allen about error claimEligibility error messages
  const orderLookupErrorCode = claimEligibilityError === null || claimEligibilityError === void 0 ? void 0 : (_claimEligibilityErro = claimEligibilityError.graphQLErrors[0]) === null || _claimEligibilityErro === void 0 ? void 0 : _claimEligibilityErro.extensions.code;
  let errorMessage;
  if (orderLookupErrorCode === 'FORBIDDEN') {
    errorMessage = claimsOrderLookupApiErrorOrderNotFound;
  } else if (claimEligibilityError) {
    errorMessage = claimsOrderLookupApiErrorUnknown;
  }
  return {
    onSubmit,
    values,
    errors,
    onChange,
    submitEnabled,
    apiErrorMessage: claimEligibilityError && !claimEligibilityLoading && errorMessage ? errorMessage : null,
    loading: loading || claimEligibilityLoading || claimEligibilityCalled && !claimEligibilityError
  };
};

exports["default"] = useOrderLookupForm;
